import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ConsentPres } from '../presentational/ConsentPres';
import {
  initPagesData,
  setCurrentPage,
  getConsentsByDefKey,
  toggleConsent,
  submitConsents,
  downloadConsent,
  setCurrentPageRead,
} from '../state/consentActions';
import { addToHistory } from 'src/utils/utilsActions';
// import { DASHBOARD_URL } from 'src/constants/constants';
import { getDashboardURL } from 'src/helpers/commonFunctions';

class ConsentContainer extends Component {
  initPageLoaded = false;

  componentDidMount() {
    let navBar = document.getElementsByClassName('nav-bar');
    if (navBar && navBar.length > 0) {
      navBar[0].style.display = 'none';
    }
    const { consentList, userRoles } = this.props.state.login;

    const consentsListByUserRole = this.validateConsentListbyUserRole(consentList, userRoles.eyPro);

    // Check if any consents needed
    if (consentsListByUserRole && consentsListByUserRole.length !== 0) {
      this.props.initPagesData(consentsListByUserRole);
      document.getElementsByClassName('consent-inner-content')[0].addEventListener('scroll', ev => {
        const el = ev.currentTarget;
        if (el.offsetHeight + el.scrollTop > el.scrollHeight - 20) {
          this.props.setCurrentPageRead(this.props.consent.pageIdx);
        }
      });
    } else {
      // Redirect to dashboard if no consents needed
      window.location.replace(getDashboardURL());
    }
  }

  validateConsentListbyUserRole(consentList, eyPro) {
    let consentListbyUserRole;
    consentListbyUserRole = consentList.length !== 0 ? consentList : eyPro ? [1] : null;
    return consentListbyUserRole;
  }

  componentDidUpdate(props) {
    if (this.props.state.consent.pages && this.props.state.consent.pageIdx === 0 && !this.initPageLoaded) {
      this.initPageLoaded = true;
      this.loadPage(0);
    }
  }

  onNextPage = () => {
    const { pageIdx, pageCount } = this.props.consent;
    document.getElementsByClassName('consent-inner-content')[0].scrollTop = 0;
    if (pageIdx < pageCount - 1) {
      this.loadPage(pageIdx + 1);
    } else {
      this.props.setCurrentPage(pageIdx + 1);
    }
  };

  getProgress = () => {
    const { pageCount, pages } = this.props.consent;
    const acceptedPages = pages.filter(p => {
      return p.accepted;
    }).length;
    return Math.round((acceptedPages / pageCount) * 100);
  };

  onPrevPage = () => {
    const { pageIdx } = this.props.consent;
    if (pageIdx > 0) {
      this.loadPage(pageIdx - 1);
    }
  };

  loadPage = pageIdx => {
    const { pages } = this.props.consent;
    if (pages.length === 0) return;
    if (pages[pageIdx].consentData) {
      this.props.setCurrentPage(pageIdx);
    } else {
      this.props.getConsentsByDefKey(pageIdx);
    }
  };

  togleConsent = (e, chkType) => {
    this.props.toggleConsent(e.currentTarget.checked, chkType);
  };

  checkSubmitDisabled = () => {
    const { pageIdx, pageCount, pages } = this.props.consent;
    if (pageIdx + 1 === pageCount) {
      for (let i = 0; i < pageCount; i++) {
        if (pages && pages[i]) {
          if (pages[i].showGDPCAccepted && (!pages[i].accepted || !pages[i].gdpcAccepted)) {
            return true;
          } else if (!pages[i].accepted) {
            return true;
          }
        }
      }
      return false;
    }
    return true;
  };

  onDownload = () => {
    const consentsToDownload = this.props.state.login.consentList;

    if (consentsToDownload && consentsToDownload !== 0) {
      let payload = { consentList: this.props.state.login.consentList };
      this.props.downloadConsent(payload);
    }
  };

  submit = () => {
    this.props.submitConsents();
  };

  nextButtonDisabled = (pageIdx, pageCount, pages) => {
    return (
      pageIdx >= pageCount ||
      (pages[pageIdx] &&
        (pages[pageIdx].showGDPCAccepted ? !pages[pageIdx].accepted || !pages[pageIdx].gdpcAccepted : !pages[pageIdx].accepted))
    );
  };

  render() {
    const { pageIdx, pageCount, pages } = this.props.consent;

    return (
      <ConsentPres
        showModal={() => {}}
        toggleModal={() => {}}
        changeMenuPage={() => {}}
        onPrevPage={this.onPrevPage}
        onNextPage={this.onNextPage}
        isNextDisabled={this.nextButtonDisabled(pageIdx, pageCount, pages)}
        onCancel={() => {}}
        onSaveDraft={() => {}}
        onSubmit={this.submit}
        onDownload={this.onDownload}
        isDraftVisible={false}
        isDraftDisabled={true}
        isSubmitDisabled={this.checkSubmitDisabled()}
        percentProgress={this.getProgress()}
        togleConsent={this.togleConsent}
        consentState={this.props.consent}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    consent: state.consent,
    state: state,
  };
};

const mapDispatchToProps = {
  initPagesData,
  setCurrentPage,
  getConsentsByDefKey,
  toggleConsent,
  submitConsents,
  downloadConsent,
  addToHistory,
  setCurrentPageRead,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsentContainer);
